import type { OperatorHomeView } from "../../../../../shared/types/operatorHome";

/**
 * Pure transform for the Operator Command Center view-model.
 *
 * Applies Number.isFinite guards on every numeric KPI field,
 * defaulting to 0 on failure. All other fields pass through unchanged.
 */
export function transformOperatorHome(raw: OperatorHomeView): OperatorHomeView {
  return {
    ...raw,
    kpis: {
      pendingApprovalsTotal: Number.isFinite(raw.kpis.pendingApprovalsTotal)
        ? raw.kpis.pendingApprovalsTotal
        : 0,
      regressionsTotal: Number.isFinite(raw.kpis.regressionsTotal)
        ? raw.kpis.regressionsTotal
        : 0,
      workspacesTouched: Number.isFinite(raw.kpis.workspacesTouched)
        ? raw.kpis.workspacesTouched
        : 0,
    },
  };
}
